module.exports = __webpack_public_path__ + "img/f39.50527ce7.png";